import AuthModule from 'modules/auth'
import LoginModule from 'modules/login'
import LoginMfaModule from 'modules/loginMfa'
import RegisterModule from 'modules/register'
import DiscordAuthModule from 'modules/discordAuth'
import CommandModule from 'modules/command'
import SearchModule from 'modules/search'
import UserMeModule from 'modules/userMe'
import NotificationsModule from "modules/notification"

export default [
  AuthModule,
  CommandModule,
  LoginModule,
  LoginMfaModule,
  RegisterModule,
  DiscordAuthModule,
  UserMeModule,
  SearchModule,
  NotificationsModule,
]
